import React from "react";
import { connect } from "react-redux";
import {
  Button,
  Col,
  DatePicker,
  Input,
  Modal,
  Row,
  Select,
  Tag,
  message,
  Typography,
} from "antd";
import BasePaginatedListComponent from "components/UI/BasePaginatedListComponent";
import moment from "moment";
import numeral from "numeral";
import queryString from "query-string";
import { push, reservedPush } from "ducks/router";
import QuestionCircleOutlined from "@ant-design/icons/QuestionCircleOutlined";
import { callGetPaginatedTaskList } from "api/Request/callGetTaskList";
import { callExtendTaskDeadline } from "api/Request/callExtendTaskDeadline";
import {
  taskTypesXuLyForSelectOnly,
  taskTypesKinhDoanhForSelectOnly,
} from "components/UI/RequestTaskInput";

const { Search } = Input;
const { RangePicker } = DatePicker;
const dateFormat = "YYYY-MM-DD";
const { Option } = Select;

@connect(({ router: { location }, app }) => {
  return { location, userState: app.userState };
})
class TaskListModal extends BasePaginatedListComponent {
  constructor(props) {
    super(props);

    this._callGetPaginatedList = callGetPaginatedTaskList;
    this.includeDateFilter = true;
    this.excludeCreateButton = true;
    this.excludeEditButtons = true;

    this.state = {
      ...this.state,
      extendModalVisible: false,
      extendTask: null,
      extendDeadline: null,
      extendSubmitting: false,
      showSearchGuideModal: false,
    };

    this._onChangePriority = this._onChangePriority.bind(this);
    this._openExtendModal = this._openExtendModal.bind(this);
    this._closeExtendModal = this._closeExtendModal.bind(this);
    this._submitExtendDeadline = this._submitExtendDeadline.bind(this);
  }

  _openSearchGuideModal = () => {
    this.setState({ showSearchGuideModal: true });
  };

  _closeSearchGuideModal = () => {
    this.setState({ showSearchGuideModal: false });
  };

  _renderSearchGuideModal = () => {
    const { showSearchGuideModal } = this.state;

    return (
      <Modal
        visible={!!showSearchGuideModal}
        title="Hướng dẫn tìm kiếm (từ khóa)"
        onCancel={this._closeSearchGuideModal}
        footer={null}
        width={720}
      >
        <Typography>
          <Typography.Paragraph>
            Ô tìm kiếm hiện tại hỗ trợ lọc theo nhân viên bằng cú pháp tiền tố.
          </Typography.Paragraph>

          <Typography.Title level={5} style={{ marginTop: 0 }}>
            Lọc theo nhân viên
          </Typography.Title>
          <Typography.Paragraph style={{ marginBottom: 8 }}>
            Cú pháp: <b>NVA:&lt;GIÁ_TRỊ&gt;</b> (không phân biệt hoa/thường).
          </Typography.Paragraph>
          <ul style={{ paddingLeft: 18, marginBottom: 0 }}>
            <li>
              <b>NVA:</b> Tìm theo <b>tên</b> hoặc <b>mã nhân viên</b>.
              <div style={{ color: "#888" }}>
                Ví dụ: <b>NVA:NVA1</b> hoặc <b>NVA:nguyen van a</b>
              </div>
            </li>
          </ul>
          <Typography.Paragraph style={{ marginBottom: 8 }}>
            Cú pháp: <b>NVB:&lt;GIÁ_TRỊ&gt;</b> (không phân biệt hoa/thường).
          </Typography.Paragraph>
          <ul style={{ paddingLeft: 18, marginBottom: 0 }}>
            <li>
              <b>NVB:</b> Tìm theo <b>tên</b> hoặc <b>mã nhân viên</b>.
              <div style={{ color: "#888" }}>
                Ví dụ: <b>NVB:NVB1</b> hoặc <b>NVB:nguyen van b</b>
              </div>
            </li>
          </ul>
        </Typography>
      </Modal>
    );
  };

  _getOrigin = () => {
    return typeof window !== "undefined" && window.location
      ? window.location.origin
      : "";
  };

  _getRequestViewPath = (id) => {
    return `/request/view/${id}`;
  };

  _disabledExtendDate = (current) => {
    if (!current) return false;
    return current < moment().startOf("day");
  };

  _disabledExtendTime = (current) => {
    if (!current) return {};

    const now = moment();
    if (!current.isSame(now, "day")) return {};

    const disabledHours = () => {
      const hours = [];
      for (let h = 0; h < now.hour(); h += 1) hours.push(h);
      return hours;
    };

    const disabledMinutes = (selectedHour) => {
      if (selectedHour !== now.hour()) return [];
      const minutes = [];
      for (let m = 0; m < now.minute(); m += 1) minutes.push(m);
      return minutes;
    };

    return { disabledHours, disabledMinutes };
  };

  _openExtendModal(record) {
    this.setState({
      extendModalVisible: true,
      extendTask: record,
      extendDeadline:
        record && record.deadline
          ? moment(record.deadline, "YYYY-MM-DD HH:mm")
          : null,
    });
  }

  _closeExtendModal() {
    this.setState({
      extendModalVisible: false,
      extendTask: null,
      extendDeadline: null,
    });
  }

  async _submitExtendDeadline() {
    const { extendTask, extendDeadline } = this.state;
    if (!extendTask || !extendTask.request_id || !extendTask.id) {
      message.error("Thiếu dữ liệu công việc");
      return;
    }
    if (
      !extendDeadline ||
      !moment.isMoment(extendDeadline) ||
      !extendDeadline.isValid()
    ) {
      message.error("Vui lòng chọn deadline mới");
      return;
    }

    try {
      this.setState({ extendSubmitting: true });
      await callExtendTaskDeadline({
        request_id: extendTask.request_id,
        task_id: extendTask.id,
        deadline: extendDeadline.format("YYYY-MM-DD HH:mm"),
      });
      message.success("Đã gia hạn deadline");
      this.setState(
        {
          extendSubmitting: false,
          extendModalVisible: false,
          extendTask: null,
          extendDeadline: null,
        },
        () => {
          this._refPaginatedTable && this._refPaginatedTable.reload();
        },
      );
    } catch (e) {
      // request util already shows toast for 400; keep a fallback
      console.log(e);
    } finally {
      // If we already closed/reset on success, this is a no-op.
      this.setState({ extendSubmitting: false });
    }
  }

  _onChangePriority(value) {
    const { dispatch, location } = this.props;
    const currParams = queryString.parse(location.search.replace("?", ""));
    const newParams = {
      ...currParams,
      priority: value || undefined,
    };
    if (!newParams.priority) {
      delete newParams.priority;
    }
    delete newParams.page;
    let search = queryString.stringify(newParams);
    search = search ? `?${search}` : "";
    dispatch(
      push({
        ...location,
        search,
      }),
    );
  }

  _renderActionButtons() {
    const { location } = this.props;
    const currParams = queryString.parse(location.search.replace("?", ""));

    const keyword = currParams.keyword;
    const fromDate = currParams.from_date ? moment(currParams.from_date) : "";
    const toDate = currParams.to_date ? moment(currParams.to_date) : "";
    const priority = currParams.priority || undefined;

    return (
      <>
        <Row type="flex" justify="space-between" gutter={5} className="mb-2">
          <Col>
            <Row gutter={10}>
              {/* <Col>
                <RangePicker
                  size="small"
                  format={dateFormat}
                  defaultValue={[fromDate, toDate]}
                  onChange={this._onChangePicker}
                />
              </Col> */}
              <Col>
                <Select
                  size="small"
                  style={{ width: 180 }}
                  allowClear
                  placeholder="Ưu tiên"
                  defaultValue={priority}
                  onChange={this._onChangePriority}
                >
                  <Option value="low">Thấp</Option>
                  <Option value="medium">Trung bình</Option>
                  <Option value="high">Cao</Option>
                  <Option value="risk">Rủi ro</Option>
                </Select>
              </Col>
              <Col>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Search
                    size="small"
                    enterButton
                    onSearch={this._onSearch}
                    placeholder="Tìm kiếm... (bấm ? để xem cú pháp)"
                    defaultValue={keyword}
                    style={{ width: 320 }}
                  />
                  <Button
                    size="small"
                    type="link"
                    icon={<QuestionCircleOutlined />}
                    onClick={this._openSearchGuideModal}
                  >
                    Hướng dẫn
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        {this._renderSearchGuideModal()}
      </>
    );
  }
  _onNameClick(id) {
    return (e) => {
      e && e.preventDefault();
      const { dispatch } = this.props;
      dispatch(reservedPush(this._getRequestViewPath(id)));
    };
  }

  _getColumns = () => {
    const userId =
      this.props && this.props.userState ? this.props.userState.id : null;

    const getMinutes = (record, minutesField, hoursField) => {
      const direct = record && record[minutesField];
      if (direct !== undefined && direct !== null && direct !== "") {
        const m = Number(direct);
        return Number.isFinite(m) ? m : 0;
      }

      const legacyHours = record && record[hoursField];
      const h = Number(legacyHours);
      if (Number.isFinite(h) && h > 0) {
        return Math.round(h * 60);
      }

      return 0;
    };

    const renderMinutesHuman = (minutes) => {
      const m = Math.max(0, Math.round(Number(minutes) || 0));
      if (!m) return "-";
      if (m >= 1440) {
        const days = m / 1440;
        return `${numeral(days).format("0.[0]")} ngày`;
      }
      if (m >= 60) {
        const hours = m / 60;
        return `${numeral(hours).format("0.[0]")} giờ`;
      }
      return `${m} phút`;
    };

    return [
      {
        title: "YC",
        dataIndex: "request_serial",
        key: "request_serial",
        render: (text, record) => (
          <a
            className="detail-link"
            onClick={this._onNameClick(record.request_id)}
            href={`${this._getOrigin()}${this._getRequestViewPath(
              record.request_id,
            )}`}
          >
            {text}
          </a>
        ),
      },
      {
        title: "Ngày bắt đầu",
        dataIndex: "start_date",
        key: "start_date",
      },
      {
        title: "Ngày kết thúc",
        dataIndex: "deadline",
        key: "deadline",
      },
      {
        title: "Còn lại",
        key: "remaining_minutes",
        width: 120,
        render: (_value, record) => {
          let remaining = getMinutes(
            record,
            "remaining_minutes",
            "remaining_hours",
          );

          // Fallback if backend doesn't provide remaining yet
          if (!remaining) {
            const elapsed = getMinutes(
              record,
              "elapsed_minutes",
              "elapsed_hours",
            );
            const duration = getMinutes(
              record,
              "duration_minutes",
              "duration_hours",
            );
            const elapsedWithin = Math.min(elapsed, duration);
            remaining = Math.max(0, duration - elapsedWithin);
          }

          if (remaining === 0) return "0 phút";
          return renderMinutesHuman(remaining);
        },
      },
      {
        title: "Quá hạn",
        key: "overtime_minutes",
        width: 120,
        render: (_value, record) => {
          const overtime = getMinutes(
            record,
            "overtime_minutes",
            "overtime_hours",
          );
          if (overtime > 0) {
            return <Tag color="#f5222d">{renderMinutesHuman(overtime)}</Tag>;
          }

          // Fallback if backend doesn't provide overtime yet
          const elapsed = getMinutes(
            record,
            "elapsed_minutes",
            "elapsed_hours",
          );
          const duration = getMinutes(
            record,
            "duration_minutes",
            "duration_hours",
          );
          const computed = Math.max(0, elapsed - duration);
          return computed > 0 ? (
            <Tag color="#f5222d">{renderMinutesHuman(computed)}</Tag>
          ) : (
            "-"
          );
        },
      },
      {
        title: "Loại (Kinh doanh)",
        dataIndex: "task_type",
        inputType: "TypeSelect",
        selectOptions: taskTypesKinhDoanhForSelectOnly,
        width: "14%",
        render: (text) => taskTypesKinhDoanhForSelectOnly[text],
        editable: true,
        inputOption: {
          rules: [
            {
              required: true,
              message: " ",
            },
          ],
        },
      },
      {
        title: "Loại (Xử lý)",
        dataIndex: "task_type",
        inputType: "TypeSelect",
        selectOptions: taskTypesXuLyForSelectOnly,
        width: "14%",
        render: (text) => taskTypesXuLyForSelectOnly[text],
        editable: true,
        inputOption: {
          rules: [
            {
              required: true,
              message: " ",
            },
          ],
        },
      },
      {
        title: "Nội dung",
        dataIndex: "content",
        key: "content",
      },
      {
        title: "NVa",
        dataIndex: "user_id_a",
        key: "user_id_a",
        render: (_text, record) => {
          if (record.user_a_obj) {
            const { identification, name } = record.user_a_obj;
            return identification ? `(${identification}) ${name}` : name;
          }
          return record.user_id_a || "";
        },
      },
      {
        title: "NVb",
        key: "user_id_b",
        dataIndex: "user_id_b",
        render: (_text, record) => {
          if (record.user_b_obj) {
            const { identification, name } = record.user_b_obj;
            return identification ? `(${identification}) ${name}` : name;
          }
          return record.user_id_b || "";
        },
      },
      {
        title: "Số lượng",
        dataIndex: "amount",
        key: "amount",
        render: (text) => {
          return numeral(text || 0).format("0,0");
        },
      },
      {
        title: "Ưu tiên",
        dataIndex: "priority",
        key: "priority",
        width: 110,
        render: (value, record) => {
          const label = record.priority_text || "-";
          return (
            <Tag
              style={{
                backgroundColor: record.priority_color || "#d9d9d9",
                color: "#fff",
                border: 0,
              }}
            >
              {label}
            </Tag>
          );
        },
      },
      {
        title: "",
        key: "extend_deadline",
        width: 110,
        render: (_text, record) => {
          const canExtend =
            userId &&
            record.user_id_b &&
            String(record.user_id_b) === String(userId);
          if (!canExtend) return null;
          return (
            <Button size="small" onClick={() => this._openExtendModal(record)}>
              Gia hạn
            </Button>
          );
        },
      },
    ];
  };

  render() {
    const base = super.render();
    const { extendModalVisible, extendDeadline, extendSubmitting } = this.state;
    return (
      <>
        {base}
        <Modal
          title="Gia hạn deadline"
          visible={extendModalVisible}
          onCancel={this._closeExtendModal}
          onOk={this._submitExtendDeadline}
          okButtonProps={{ loading: extendSubmitting }}
          destroyOnClose
        >
          <div style={{ marginBottom: 8 }}>Chọn deadline mới</div>
          <DatePicker
            style={{ width: "100%" }}
            showTime={{ format: "HH:mm" }}
            format="YYYY-MM-DD HH:mm"
            value={extendDeadline}
            defaultPickerValue={moment()}
            disabledDate={this._disabledExtendDate}
            disabledTime={this._disabledExtendTime}
            onChange={(val) => this.setState({ extendDeadline: val })}
          />
        </Modal>
      </>
    );
  }
}
export default TaskListModal;
